import { Spin } from "antd";

const AppLoader = ({ children, component, ...rest }) => {
  return (
    <div
      style={{
        maxWidth: "fit-content",
        marginInline: "auto",
        marginTop: "100px",
      }}
    >
      <Spin size="large" tip={"Loading..."}>
        <p style={{ color: "transparent" }}>Loading</p>
      </Spin>
    </div>
  );
};

export default AppLoader;
